import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 8px;
  grid-row-gap: 8px;

  align-items: start;

  & > * {
    grid-auto-rows: min-content;
  }
`;
